import { TextField } from '@mui/material';
import React from 'react';

const MuiInput = (props) => {
    return (
        <TextField fullWidth margin="normal" {...props} />
    )
}
export default MuiInput